import { Component } from '@angular/core';
import { BulkImportMeta } from '@app/modules/reporting/interfaces/bulk-import-meta-data.interface';
import { FeatureService } from '@app/services/feature.service';
import { BULK_IMPORT_META_DATA } from '@reporting/views/bulk-import/bulk-import-config';

@Component({
    templateUrl: './bulk-import-selection.view.html',
})
export class BulkImportSelectionView {
    imports: BulkImportMeta[] = [];

    constructor(private featureService: FeatureService) {
        this.featureFlagFilterMetaData();
    }

    async featureFlagFilterMetaData(): Promise<void> {
        for (const importMeta of BULK_IMPORT_META_DATA) {
            if (importMeta.showIfHasFeatureFlag && !(await this.featureService.has(importMeta.showIfHasFeatureFlag))) {
                continue;
            }

            if (importMeta.hideIfHasFeatureFlag && (await this.featureService.has(importMeta.hideIfHasFeatureFlag))) {
                continue;
            }

            this.imports.push(importMeta);
        }
    }
}
